import { getUrl } from 'helpers';
import { CSSProperties, useEffect, useState } from 'react';

export default function Image({ alt, height, maxHeight, maxWidth, src, width }: ImageProps) {

    const [imgSrc, setImgSrc] = useState<string | undefined>(undefined);
    const [imgStyle, setImgStyle] = useState<CSSProperties>({});

    useEffect(() => {
        const newImgSrc = src ? getUrl(src) : undefined;
        setImgSrc(newImgSrc);
    }, [
        src,
    ]);

    useEffect(() => {
        const newStyle = {
            height,
            maxHeight,
            maxWidth: maxWidth || '100%',
            width: width || '100%',
        };
        setImgStyle(newStyle);
    }, [
        height,
        maxHeight,
        maxWidth,
        width,
    ]);

    return (
        <picture>
            <img alt={alt} aria-hidden={alt === '' ? true : undefined} src={imgSrc} style={imgStyle} />
        </picture>
    );

}